import MainLayout from "@/layouts/MainLayout";
import HeroSlider from "@/components/HeroSlider";
import BusinessMottoSection from "@/components/BusinessMottoSection";
import AboutSection from "@/components/AboutSection";
import GamesSection from "@/components/GamesSection";
import QuoteSection from "@/components/QuoteSection";

import NewsSection from "@/components/NewsSection";
import { useSiteSettings } from "@/contexts/SiteSettingsContext";

const Index = () => {
  const { settings } = useSiteSettings();
  return (
    <MainLayout>
      <HeroSlider />
      {settings.homepage_business_motto_enabled !== "false" && <BusinessMottoSection />}
      {settings.homepage_about_enabled !== "false" && <AboutSection />}
      <GamesSection />
      <QuoteSection />
      <NewsSection />
    </MainLayout>
  );
};

export default Index;
